import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Menu, pxToRem } from '@pocketlaw/tetris';
import { SidebarMenuUser } from 'app/domains/common-ui';
import { AddCompanyDialog } from 'app/domains/company';
import { useMobile } from 'shared/domains/common-ui';
import { useAccount } from 'shared/domains/users';
import { AccountInfoSection } from './AccountInfoSection';
import { CompanySelector } from './CompanySelector';
import { LanguageSelector } from './LanguageSelector';
export function UserAccountMenu() {
    var _a, _b;
    const { data: accountData } = useAccount();
    const [renderCreateCompanyDialog, setRenderCreateCompanyDialog] = useState(false);
    const isMobile = useMobile();
    const userName = ((_a = accountData.profile) === null || _a === void 0 ? void 0 : _a.name) || '';
    const companyName = ((_b = accountData.company) === null || _b === void 0 ? void 0 : _b.name) || '';
    const minimizedTooltip = t({
        comment: 'Sidebar menu - User settings tooltip label',
        message: 'User settings',
    });
    const showCreateDialog = () => setRenderCreateCompanyDialog(true);
    const hideCreateDialog = () => setRenderCreateCompanyDialog(false);
    return (<Fragment>
      {renderCreateCompanyDialog && <AddCompanyDialog onClose={hideCreateDialog}/>}

      <Menu.Root side={isMobile ? 'top' : 'right'} minWidth={pxToRem(300)} maxWidth={pxToRem(400)} target={<div>
            <SidebarMenuUser userName={userName} companyName={companyName} minimizedTooltip={minimizedTooltip}/>
          </div>}>
        <AccountInfoSection />

        <Menu.Divider />

        <CompanySelector onShowCreateCompanyDialog={showCreateDialog}/>

        <Menu.Divider />

        <LanguageSelector />
      </Menu.Root>
    </Fragment>);
}
